module.exports = __webpack_public_path__ + "img/profCand.04fbc9c1.svg";